// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3v4eR","legacyBtn":"MutateMid_legacyBtn__3ZXuV"};